import IconButton from "@material-ui/core/IconButton";
import MenuIcon from '@material-ui/icons/Menu';

function Menu({ navToggle, setNavToggle }) {
    return (
        <div className="menu">
            <IconButton onClick={() => setNavToggle(!navToggle)}>
                <MenuIcon />
            </IconButton>
        </div>
    )
}
export default Menu